```vue
<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import ProductsSection from './components/ProductsSection.vue'
import OrderSummary from './components/OrderSummary.vue'
import { CashierDuty, Item, ItemCategory, ItemGroup, PaymentType, PosStation, RestaurantTables, SalesRep } from '../../../../types/models';
import { User } from '../../../../types/auth';

defineProps<{
  isFullscreen: boolean,
  payment_types: PaymentType[]
  item_categories: ItemCategory[]
  item_groups: ItemGroup[]
  delivery_staffs: User[]
  posStation: PosStation | undefined
  cashierDuty: CashierDuty | null
  salesReps: SalesRep[]
}>()

const emit = defineEmits<{
  (e: 'addItem', item: Item): void
  (e: 'close'): void
  (e: 'back'): void
  (e: "order-created", tables: RestaurantTables[]): void;
  (e: "view-bill", table: RestaurantTables): void;
}>()

const handleAddItem = (item: Item) => {
  emit('addItem', item)
}

const productsSectionRef = ref<InstanceType<typeof ProductsSection> | null>(null)
const orderSummaryRef = ref<InstanceType<typeof OrderSummary> | null>(null)

// Expose focusSearch method for parent component
defineExpose({
  focusSearch() {
    productsSectionRef.value?.focusSearch()
  }
})

onMounted(() => {
  // Focus the product search input when component is mounted
  productsSectionRef.value?.focusSearch()
  //window.addEventListener('pos-checkout', handleCheckout)
})

onUnmounted(() => {
  //window.removeEventListener('pos-checkout', handleCheckout)
})

const orderCreated = (tables: RestaurantTables[]) => {
  emit("order-created", tables);
}

const handleNew = () => {
  nextTick(() => {
    productsSectionRef.value?.focusSearch()
  })
}
</script>

<template>
  <div class="h-full">
    <!-- Main Content -->
    <div class="flex gap-6 h-full p-6">
      <!-- Products Section (Left) -->
      <div class="flex-1 overflow-hidden">
        <ProductsSection 
          ref="productsSectionRef"
           @add-item="handleAddItem"
           :delivery_staffs="delivery_staffs"
            :pos-station="posStation"
            :item_categories="item_categories"
            :item_groups="item_groups"
            :payment_types="payment_types"
          :is-fullscreen="isFullscreen" 
        />
      </div>

      <!-- Summary Section (Right) -->
      <div 
        class="w-96 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700"
        :class="[isFullscreen ? '' : 'sticky top-24']"
      >
        <OrderSummary ref="orderSummaryRef" :delivery_staffs="delivery_staffs"
              :pos-station="posStation"
              :item_categories="item_categories"
              :salesReps="salesReps"
              :cashierDuty="cashierDuty"
              @new="handleNew"
              @view-bill="emit('view-bill', $event)"
              @back="emit('back')"
              @order-created="orderCreated"
              :item_groups="item_groups"
              :payment_types="payment_types"/>
      </div>
    </div>
  </div>
</template>
```